<template>
  <pt-integral-goods-detail :goodsDetail="goodsDetail" :mallGoods="mallGoods" class="pt-integral-goods-detail__withData"></pt-integral-goods-detail>
</template>

<script>
import PtIntegralGoodsDetail from './index'
export default {
  name: 'pt-integral-goods-detail__withData',
  components: {
    'pt-integral-goods-detail': PtIntegralGoodsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      goodsDetail: {},
      mallGoods: {}
    }
  },
  methods: {
    getIntegralGoodsDetail () {
      let data = {
        id: this.id
      }
      this.$store.dispatch('getIntegralGoodsDetail', data).then(res => {
        console.log('res', res)
        this.goodsDetail = res.goodsDTO
        // this.mallGoods = res.mallGoods || {}
      }).catch(err => {
        this.$message.error(err || '获取积分商品详情失败')
      })
    }
  },
  created () {
    this.getIntegralGoodsDetail()
  }
}
</script>
<style lang="less">
.pt-integral-goods-detail__withData{
  td{
    padding-bottom: 0!important
  }
}
</style>
